import React, { useState, useContext, useEffect, useCallback } from "react";
import { UpdateContext } from "../main-context.js";
import login_css from "./login.module.css";
import { login, getFromDbIndex, clearDbIndex } from "../lib/comm.js";
import { useHistory } from "react-router-dom";
import { settings } from "../settings/configuration.js";

export default function Login() {
  const [username, set_username] = useState("");
  const [password, set_password] = useState("");
  const [checkbox, set_checkbox] = useState(false);
  const update_context = useContext(UpdateContext);
  const history = useHistory();

  const processResponse = useCallback(
    (res) => {
      if (res === "comm error") {
        clearDbIndex();
        return;
      }
      const groups = {};
      for (const group of res.groups) {
        groups[Object.keys(group)[0]] = group[Object.keys(group)[0]];
      }
      update_context.update_main_context((prev) => ({
        ...prev,
        equipmentTypes: res.equipmentTypes.reduce((prev, cur) => {
          prev[cur.id] = cur.name;
          return prev;
        }, {}),
        status: {
          ...prev.status,
          authorized: true,
          username: username,
          id: res.id,
          group: res.group,
          first_name: res.first_name,
          last_name: res.last_name,
          is_nata_user: res.is_nata_user,
          has_station: res.has_station,
          station_id: res.station_id,
          vendor_id: res.vendor_id,
          station: res.station,
          vendor: res.vendor,
          preferences: res.preferences,
          can_change_prefs: res.can_change_prefs,
          date_string: res.date_string,
          get_full_name: res.first_name + " " + res.last_name,
        },
        groups: groups,
      }));

      history.push(update_context.settings.subfolder);
    },
    [history, update_context, username]
  );

  const submit = async (event) => {
    event.preventDefault();
    const res = await login(
      "/offline/login",
      {
        username: username,
        password: password,
      },
      update_context
    );
    processResponse(res);
  };

  useEffect(() => {
    if (!username) {
      getFromDbIndex("/offline/login", processResponse, update_context, false);
    }
  }, [processResponse, update_context, username]);

  return (
    <div className={login_css["login-background"]}>
      <div className={login_css["center-container"]}>
        <div className="container">
          <div className={"row " + login_css["login-row"]}>
            <div className={"text-center " + login_css["login-window"]}>
              <div className={login_css.headerlogo}></div>
              <h2 className={login_css["login-title"]}>OFFLINE LOGIN</h2>
              <form
                action=""
                method="post"
                className={login_css["login-form"]}
                onSubmit={submit}
              >
                <div
                  className={
                    "form-group form-username " + login_css["login-form-group"]
                  }
                >
                  <span className={login_css["icon-holder"]}>
                    <div className={login_css["user-icon"]}></div>
                  </span>
                  <input
                    type="text"
                    autoFocus
                    className={
                      "form-control " +
                      login_css["login-input"] +
                      " " +
                      login_css["form-control"]
                    }
                    name="username"
                    id="username"
                    placeholder="Username"
                    value={username}
                    onChange={(event) => set_username(event.target.value)}
                  />
                </div>
                <div
                  className={"form-group mb-0 " + login_css["login-form-group"]}
                >
                  <span className={login_css["icon-holder"]}>
                    <div className={login_css["lock-icon"]}></div>
                  </span>
                  <input
                    type="password"
                    className={
                      "form-control " +
                      login_css["login-input"] +
                      " " +
                      login_css["form-control"]
                    }
                    name="password"
                    id="exampleInputPassword1"
                    placeholder="Password"
                    value={password}
                    onChange={(event) => set_password(event.target.value)}
                  />
                </div>
                <div className={"checkbox " + login_css["login-checkbox"]}>
                  <label>
                    <input
                      type="checkbox"
                      value={checkbox}
                      onChange={(event) => set_checkbox(event.target.checked)}
                    />
                    Remember me
                  </label>
                </div>
                <button
                  type="submit"
                  className={"btn btn-default mb-1 " + login_css["login-btn"]}
                >
                  Login
                </button>
                <div className={login_css["login-footer"]}>
                  <span className={login_css["left"]}>Switch to Online?</span>
                  &nbsp;
                  <a
                    className={login_css["right"]}
                    href={settings.url + "/login"}
                  >
                    Click here
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
